// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { typeAheadPlugin } from '@atlaskit/editor-plugin-type-ahead';
export type {
	TypeAheadPlugin,
	TypeAheadHandler,
	TypeAheadInputMethod,
	TypeAheadPluginOptions,
	TypeAheadPluginState,
	TypeAheadPluginSharedState,
} from '@atlaskit/editor-plugin-type-ahead';
